import { CSSProperties, MouseEventHandler } from "react";

const SvgQuestionMark: React.FC<{
  fill?: React.SVGAttributes<string>["fill"];
  onClick?: MouseEventHandler<SVGSVGElement>;
  size?: number | string;
  style?: CSSProperties;
}> = ({ fill = "#F08E33", onClick, size = "10", style }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={style}
    >
      <g clip-path="url(#clip0_26147_1960)">
        <path
          d="M4.99992 0.833374C2.70242 0.833374 0.833252 2.70254 0.833252 5.00004C0.833252 7.29754 2.70242 9.16671 4.99992 9.16671C7.29742 9.16671 9.16658 7.29754 9.16658 5.00004C9.16658 2.70254 7.29742 0.833374 4.99992 0.833374ZM4.99992 7.50004C4.76971 7.50004 4.58325 7.31358 4.58325 7.08337C4.58325 6.85317 4.76971 6.66671 4.99992 6.66671C5.23013 6.66671 5.41658 6.85317 5.41658 7.08337C5.41658 7.31358 5.23013 7.50004 4.99992 7.50004ZM5.62284 5.20358C5.41617 5.36462 5.31242 5.44546 5.31242 5.72921C5.31242 5.90192 5.17263 6.04171 4.99992 6.04171C4.82721 6.04171 4.68742 5.90192 4.68742 5.72921C4.68742 5.14004 5.00596 4.89192 5.23867 4.71067C5.46284 4.53587 5.62492 4.40962 5.62492 3.95837C5.62492 3.61379 5.3445 3.33337 4.99992 3.33337C4.65534 3.33337 4.37492 3.61379 4.37492 3.95837V4.06254C4.37492 4.23525 4.23513 4.37504 4.06242 4.37504C3.88971 4.37504 3.74992 4.23525 3.74992 4.06254V3.95837C3.74992 3.269 4.31054 2.70837 4.99992 2.70837C5.68929 2.70837 6.24992 3.269 6.24992 3.95837C6.24992 4.71483 5.88742 4.99733 5.62284 5.20358Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_26147_1960">
          <rect width="10" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgQuestionMark;
